module.exports = __webpack_public_path__ + "img/sentaosa-qr.9b13df59.png";